import React from 'react'

const withReloadableURL = getOptions => WrappedComponent => {
  return class ReloadableURL extends React.Component {
    state = {
      source: undefined,
    }

    componentWillMount() {
      this.setState({ source: this.getOriginalURL() })
    }

    getOriginalURL = () => {
      const { originalURL } = getOptions(this.props)
      return originalURL
    }

    handleReloadURL = (ref) => {

      let imageURLTrailing = '?' + new Date().getTime()

      console.log(this.getOriginalURL())

      this.setState({
        source: this.getOriginalURL() + imageURLTrailing,
      })
    }

    render() {
      if (this.state.source)
        return (
          <WrappedComponent
            {...this.props}
            source={this.state.source}
            onReloadURL={this.handleReloadURL}
          />
        )

      return null
    }
  }
}

export default withReloadableURL



// WEBPACK FOOTER //
// ./src/modules/image/withReloadableURL.js